
const digest = '01f7c4ba00e10b2fcdcc44009104e298b3633206cf0deec7e72da92cc4c72e31';
const classes = {"zoom":"_zoom_wsm4d_1","wrapper":"_wrapper_wsm4d_9","buttonWrapper":"_buttonWrapper_wsm4d_15"};
const css = `._zoom_wsm4d_1 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  margin: 20px 0;
}

._wrapper_wsm4d_9 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
}

._buttonWrapper_wsm4d_15 {
  margin-top: 60px;
  display: flex;
  justify-items: center;
  align-items: center;
  flex-direction: row;
  justify-content: space-around;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  